export default __webpack_public_path__ + "static/media/citysquare_logo.c571dffd.png";